import React from 'react'

import { SecondaryNavLayout } from 'src/modules/ui'

import InvoiceList from './InvoiceList'
import ViewInvoice from './ViewInvoice'
// import DisputeInvoice from './DisputeInvoice'

const Invoices = () => {
  const routes = [
    {
      navLabel: 'Invoices',
      path: `/invoices/list`,
      render: props => <InvoiceList />,
    },
    // {
    //   path: `/invoices/:id/dispute`,
    //   component: DisputeInvoice,
    //   title: 'Dispute Invoice',
    // },
    {
      path: `/invoices/:id`,
      component: ViewInvoice,
      title: 'Invoice',
    },
  ]

  return <SecondaryNavLayout routes={routes} />
}
export default Invoices
